// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__r8BcO","body":"style__body__iW9AP","header":"style__header__3GYDy","footer":"style__footer__BLTzc","footerContent":"style__footerContent__ix76D"};